@if (auth.user(); as user) {
  <button
    #chip
    type="button"
    class="chip"
    aria-label="Mein Konto Menü"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-controls]="panelId"
    (click)="toggle()"
  >
    <span aria-hidden="true">{{ initials() }}</span>
  </button>
  <div class="panel" [id]="panelId" [hidden]="!isOpen()">
    <p class="overline">
      Mein Konto
      @if (user.tenant) {
        · Mandant {{ user.tenant }}
      }
    </p>
    <p class="name">{{ user.name }}</p>
    @if (user.email) {
      <p class="email">{{ user.email }}</p>
    }
    <hr />
    <button type="button" class="logout" (click)="auth.logout()">
      <ez-icon name="logout" />
      Abmelden
    </button>
  </div>
}
